import { OverlayRef } from '@angular/cdk/overlay';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { ErrorList } from './error-list.model';
import { Errors } from './errors';
import { Dimensions } from './dimensions';

@Component({
    selector: 'error-prompt-messages',
    templateUrl: './error-prompt-messages.component.html'
})
export class ErrorPromptMessagesComponent implements OnInit {

    // Properties
    errorList: ErrorList[] = [];

    // Class Functions
    constructor(
        private errors: Errors,
        private sanitizer: DomSanitizer,
        private overlayRef: OverlayRef,
        private elementRef: ElementRef,
        private dimensions: Dimensions
    ) { }

    // Event Functions
    ngOnInit() {
        this.errorList = this.errors.errorList;
    }

    // Methods

    errorLinkClick(error: ErrorList) {
    	// PRE: an error's link is clicked
		// POST: changes the focus to that field and calls the callback
        if (error.fieldRef) {
            error.fieldRef.nativeElement.focus();
        }
    	if (error.clickCallback) {
            error.clickCallback(error.object);
		}
        this.overlayRef.dispose();
	}

    @HostListener('document:click', ['$event'])
    onClick(event) {
        // PRE: the dom is clicked outside of the error messages
        // POST: removes this from the dom
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.overlayRef.dispose();
        }
    }
}
